import React from 'react';
import { Helmet } from 'react-helmet';
import { ROUTES } from '../../lib/constants';
import styles from './LegalPages.module.scss'
import { Link } from 'react-router-dom';

export const Policies = (): React.JSX.Element => {

  return (
    <>
      <Helmet>
        <title>{ROUTES.policies.title}</title>
      </Helmet>
      <div className='grid-12'>
        <div className={styles.container}>
          <h1>
            Our Policies
          </h1>

          <section className={styles.content}>
            <p className='subtitle italic color--marina-blue' style={{textAlign: 'center'}}>
              Please review the policies, terms, and conditions at the links provided below
            </p>

            <p style={{textAlign: 'center'}}>
              <Link className='focus-contrast' to={ROUTES.websiteTerms.path}>
                  Website Terms of Use
              </Link>
            </p>

            <p style={{textAlign: 'center'}}>
              <Link className='focus-contrast' to={ROUTES.privacy.path}>
                  Privacy Policy
              </Link>
            </p>

            <p style={{textAlign: 'center'}}>
              <Link className='focus-contrast' to={ROUTES.aup.path}>
                  Acceptable Use Policy
              </Link>
            </p>

            <p style={{textAlign: 'center'}}>
              <Link className='focus-contrast' to={ROUTES.residentialTerms.path}>
                Residential Service Terms & Conditions
              </Link>
            </p>

            <p style={{textAlign: 'center'}}>
              <Link className='focus-contrast' to={ROUTES.commercialTerms.path}>
                SMB Services Agreement
              </Link>
            </p>

            <p style={{textAlign: 'center'}}>
              <Link className='focus-contrast' to={ROUTES.dmcaPolicy.path}>
                DMCA Policy
              </Link>
            </p>

            <p style={{textAlign: 'center'}}>
              <Link className='focus-contrast' to={ROUTES.betaAgreement.path}>
                Beta Agreement
              </Link>
            </p>

          </section>
        </div>
      </div>
    </>
  )
}